<div class="reset-container">
  <p class="text-center"><img src="{{ 'APP.LOGO' | translate }}" width="300" alt="logo"/></p>
  
  <p class="text-center info">
    {{'forgot_password.first_info' | translate}}
    <br/>
    <span class="legend">{{'forgot_password.sencond_info' | translate}}</span>
  </p>
  
  <form class="login-form" novalidate (ngSubmit)="onSubmit(reset)" [formGroup]="reset" >
    <input required formControlName="email"
           name="email"
           type="email"
           class="form-control"
           placeholder="{{'forgot_password.email_placeholder' | translate}}"
           email />
    <button [disabled]="reset.invalid"
            type="submit"
            class="btn btn-default">{{'forgot_password.send_btn' | translate}}</button>
  </form>
  
  <p class="message">
      <span *ngIf="successMessage" class="success">{{successMessage}}</span>
      <span *ngIf="errorMessage" class="error" [innerHTML]="errorMessage"></span>
  </p>

  <p class="text-center email-spam-warning">{{'forgot_password.email_spam_warning' | translate}}</p>
</div>



// WEBPACK FOOTER //
// ./src/app/auth/reset/reset.component.html